import styled from 'styled-components';

export const SectionContainer = styled.div`
    background: #ffffff;
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    border: 1px solid #eef1f3;
    border-radius: 16px;
    overflow: hidden;
    transition: box-shadow 0.2s ease;

    &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }
`;
